<template>
  <v-row class="justify-center">
    <v-col cols="12" xs="12" sm="6" md="4" lg="4" class="d-flex align-stretch pa-1">
      <v-card  class="flex-grow-1">
        <v-card-subtitle class="title" pa-5>Cliente,  acesse o seu <br><b>Espaço pra você!</b></v-card-subtitle>
        <v-card-text class="text--primary pb-0">
          <v-form ref="loginForm" v-model="validLoginForm" lazy-validation>
            <v-col cols="12" class="pb-0">
              <v-text-field
                label="CPF"
                dense
                v-model="formData.cpf"
                :rules="$store.state.formRules.cpfRules"
                v-mask='"###.###.###-##"'
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="pt-0">
              <v-text-field
                label="Senha"
                dense
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show1 ? 'text' : 'password'"
                v-model="formData.senha"
                :rules="[$store.state.formRules.rulesPass.required]"
                @click:append="show1 = !show1"
                outlined
              ></v-text-field>
            </v-col>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text color="accent" @click="cadastrar(true)">ESQUECEU A SENHA?</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="login">ENTRAR</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
    <v-col cols="12"  xs="12" sm="6" md="4" lg="4" class="d-flex align-stretch pa-1">
      <v-card class="flex-grow-1">
        <v-card-subtitle class="title">Não possui login e senha?</v-card-subtitle>
        <v-card-text class="text--primary mt-9 justify-center pa-3">
          <v-btn block color="primary" class="authOthersBtn mt-2" @click="cadastrar(false)">MEU PRIMEIRO ACESSO</v-btn>
          <v-btn block color="primary darken-1" class="authOthersBtn mt-2" to="/2aviaboletos">2ª VIA DE BOLETO</v-btn>
        </v-card-text>
        <v-card-actions>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mask } from 'vue-the-mask'
export default {
  directives: {
      mask,
    },
  props: {
    errors: String
  },
  data() {
    return {
      formData: {
        cpf: null,
        senha: null
      },
      logo: {
        restrictedarea: "Área restrita",
        src: "./assets/logo.png",
        title: "InSight Síndicos",
        txt: "Faça login para acessar o sistema."
      },
      show1: false,
      validLoginForm: true
    };
  },
  computed: {
     esquecisenha () { return this.$store.state.plans.esquecisenha }
  },
  mounted() {
    //alert('aqui')
    if (this.errors) {
      let opts = {
        message: this.errors,
        type: "error"
      };
      this.$store.commit("showAlert", opts);
    }
  },
  methods: {
    login() {
      if (!this.$refs.loginForm.validate()) {
        return;
      }
      const _this = this;
      this.$store.commit("showLoader", {
        circle: true
      });
      if (this.$refs.loginForm.validate()) {
        this.$store.dispatch("request/doLogin", this.formData)
      }
    },
    cadastrar(esquecisenha){
      this.$store.commit("plans/esquecisenha", esquecisenha)
      this.$router.push("/cadastro")
    }
  }
}
</script>
